/**
 * Crea una cookie en el navegador.
 * @param name - El nombre de la cookie.
 * @param value - El valor de la cookie.
 * @param days - Opcional: El número de días hasta que la cookie expire.
 * @param path - Opcional: La ruta donde la cookie es válida (por defecto es "/").
 * @param secure
 * @param sameSite
 */
export const createCookie = (name: string, value: string, days: number = 7, path: string = '/', secure: boolean = true, sameSite: 'Lax' | 'Strict' | 'None' = 'Lax') => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);

  const expires = `expires=${d.toUTCString()}`;
  const secureFlag = secure ? 'Secure;' : '';
  document.cookie = `${name}=${value}; ${expires}; path=${path}; ${secureFlag} SameSite=${sameSite}`;
};

/**
 * Retorna el valor de una cookie o undefined si no existe
 * @param name
 */
export const getCookieValue = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : undefined;
};
